import { render, staticRenderFns } from "./GlobalMessage.vue?vue&type=template&id=27d2952e"
import script from "./GlobalMessage.vue?vue&type=script&lang=js"
export * from "./GlobalMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports